/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Delete_BtnInputs */

const en_story_bank_delete_btn = /** @type {(inputs: Story_Bank_Delete_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

const de_story_bank_delete_btn = /** @type {(inputs: Story_Bank_Delete_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

const fr_story_bank_delete_btn = /** @type {(inputs: Story_Bank_Delete_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

const es_story_bank_delete_btn = /** @type {(inputs: Story_Bank_Delete_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

const it_story_bank_delete_btn = /** @type {(inputs: Story_Bank_Delete_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

const nl_story_bank_delete_btn = /** @type {(inputs: Story_Bank_Delete_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

const pl_story_bank_delete_btn = /** @type {(inputs: Story_Bank_Delete_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

const fi_story_bank_delete_btn = /** @type {(inputs: Story_Bank_Delete_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

const da_story_bank_delete_btn = /** @type {(inputs: Story_Bank_Delete_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

const sv_story_bank_delete_btn = /** @type {(inputs: Story_Bank_Delete_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Story_Bank_Delete_BtnInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_delete_btn = /** @type {((inputs?: Story_Bank_Delete_BtnInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Delete_BtnInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_delete_btn(inputs)
	if (locale === "fr") return fr_story_bank_delete_btn(inputs)
	if (locale === "es") return es_story_bank_delete_btn(inputs)
	if (locale === "it") return it_story_bank_delete_btn(inputs)
	if (locale === "nl") return nl_story_bank_delete_btn(inputs)
	if (locale === "pl") return pl_story_bank_delete_btn(inputs)
	if (locale === "fi") return fi_story_bank_delete_btn(inputs)
	if (locale === "da") return da_story_bank_delete_btn(inputs)
	if (locale === "sv") return sv_story_bank_delete_btn(inputs)
	return en_story_bank_delete_btn(inputs)
});